import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators as bind } from 'redux';

class TestContainer extends Component {
  state = { val: null };

  render() {
    return (
      <div>
        <h1>Test</h1>
        <input type="text" />
        <label for="male" tabIndex="0">
          <input type="checkbox" id="female" name="gender" value="male" />
          Male
        </label>
        <input type="checkbox" id="female" name="gender" value="female" />
        <label for="female">Female</label>
        <input type="checkbox" id="other" name="gender" value="other" />
        <label for="other">Other</label>
        <input type="text" />
      </div>
    );
  }
}

export default TestContainer;
